import {ToggleButton} from '@wandb/components';
import React from 'react';

type RowPinningProps = {
  isRunPinned: boolean;
  isSingleMode: boolean;
  onUnpinRow: () => void;
};

export function RowPinning({
  isRunPinned,
  isSingleMode,
  onUnpinRow,
}: RowPinningProps) {
  if (isSingleMode || !isRunPinned) {
    return null;
  }

  return (
    <ToggleButton
      aria-label="Unpin run"
      onPress={onUnpinRow}
      isSelected
      size="sm"
      tooltip={{children: 'Click to remove pin'}}
      variant="pin"
    />
  );
}
